export const ACCEPT_TYPES = ['.jpg', '.jpeg', '.png','.svg','.webp']; // '.gif', '.bpm',

export const ACCEPT_IMAGE_SIZE = 10485760; // 10mb

export const MIN_PRICE = 0;

export const MAX_PRICE = 1000000;
